import { createAction, props } from '@ngrx/store';

export enum ChatActionTypes {
  SetChatBoxMinimized = '[Chat] Set Chat Box Minimized',
  SetMessages = '[Chat] Set Messages',
  SetChatBoxVisibility = '[Chat] Set Chat Box Visibility',
}

export const setChatBoxMinimized = createAction(
  ChatActionTypes.SetChatBoxMinimized,
  props<{ isMinimized: boolean }>()
);

export const setMessages = createAction(
  ChatActionTypes.SetMessages,
  props<{ messages: any[] }>()
);

export const setChatBoxVisibility = createAction(
  ChatActionTypes.SetChatBoxVisibility,
  props<{ showChatBox: boolean }>()
);
